import { Box, styled } from '@mui/material';

export const QuickLinkCircle = styled(Box)(({ theme }) => ({
  borderRadius: '50%',
  backgroundColor: theme.palette.common.white,
  width: theme.spacing(5),
  height: theme.spacing(5),
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  flexShrink: 0,
  [theme.breakpoints.up('sm')]: {
    width: theme.spacing(5.75),
    height: theme.spacing(5.75),
  },
  [theme.breakpoints.up('md')]: {
    width: theme.spacing(8),
    height: theme.spacing(8),
  },
  '& svg': {
    fill: theme.palette.periwinkle.main,
  },
}));
